// Not using the default because we need some costumization
// import '@codevise/activeadmin-searchable_select';
const pageParamWithBaseZero = params => params.page ? params.page - 1 : undefined

// get the selected object ids of all select inputs
const getSelectedObjectIds = inputs => {
  const ids = []
  inputs.each(function () {
    const data = $(this).select2('data')
    const selected = data.find(({ selected }) => selected)

    if (selected && selected.id !== '') {
      ids.push(selected.id)
    }
  })

  return ids
}

const initSearchableSelects = (inputs, extra) => {
  inputs.each(function() {
    const item = $(this)
    var options = $.extend(extra || {}, item.data('searchableSelect'))
    var url = item.data('ajaxUrl')
    
    $.extend(options, {
      tags: true,
      language: 'it',
      width: '80%',
      ajax: {
        url: url,
        dataType: 'json',
        data: params => {
          const selectedObjectIds = getSelectedObjectIds(inputs)
          return {
            term: params.term,
            page: pageParamWithBaseZero(params),
            selected_object_ids: selectedObjectIds
          }
        }
      }
    })

    item.select2(options)
  })
}

// on page ready
$(() => {
  initSearchableSelects($('.searchable-select-input'), { placeholder:  '' })
})

// on has_many associated change
$(document).on('has_many_add:after', () => { initSearchableSelects($('.searchable-select-input')) })
$(document).on('has_many_remove:after', () => { initSearchableSelects($('.searchable-select-input')) })
